import React from "react";
import Categoriproduct from "../components/ui/Categoriproduct";

const Productview = () => {
  return (
    <div>
      <Categoriproduct />
    </div>
  );
};

export default Productview;
